import { createContext, useContext, type ReactNode } from 'react';

const PreviewContext = createContext(false);

export const PreviewProvider: React.FC<{ isPreview: boolean; children: ReactNode }> = ({ isPreview, children }) => (
  <PreviewContext.Provider value={isPreview}>{children}</PreviewContext.Provider>
);

export const useIsPreview = (): boolean => useContext(PreviewContext);
